import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './sass/style.sass';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Root from './Root';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider className="grecaptcha-badge" reCaptchaKey="6LfIacwtAAAAAGXgQ-knbNOUairZu7jXc8J68Nta">
    <BrowserRouter>
      <Root />
    </BrowserRouter>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);
